import axios from "axios";
import { LicenseRequest } from "@/models/licence-request.model";
import { License } from "@/models/license.model";

class LicenseService {
    /**
     * Generuje nową licencję dla klienta
     * @param clientId ID klienta
     * @param licenseRequest Dane do generowania licencji
     */
    async generateLicense(clientId: string, licenseRequest: LicenseRequest): Promise<void> {
        const formData = new FormData();
        if (licenseRequest.licenceRequest) {
            formData.append("LicenceRequest", licenseRequest.licenceRequest);
        }
        if (licenseRequest.validTo) {
            formData.append("ValidTo", licenseRequest.validTo);
        }

        formData.append("HasDiscussion", String(licenseRequest.hasDiscussion));
        formData.append("HasAV", String(licenseRequest.hasAV));
        formData.append("HasFA", String(licenseRequest.hasFA));
        formData.append("HasVoting", String(licenseRequest.hasVoting));
        formData.append("HasNfc", String(licenseRequest.hasNfc));
        formData.append("HasOnlineStatus", String(licenseRequest.hasOnlineStatus));
        formData.append("HasWirelessData", String(licenseRequest.hasWirelessData));
        formData.append("HasScreenIdentification", String(licenseRequest.hasScreenIdentification));

        await axios.post(`/client/${clientId}/licenses`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    }


    /**
   * Pobiera listę licencji dla klienta
   * @param clientId ID klienta
   */
    async getClientLicenses(clientId: string): Promise<License[]> {
        const response = await axios.get<License[]>(`/client/${clientId}/licenses`);
        return response.data;
    }

    /**
     * Pobiera plik licencji w kontekście klienta
     * @param clientId ID klienta
     * @param licenseId ID licencji
     */
    async downloadLicense(clientId: string, licenseId: string): Promise<void> {
        const response = await axios.get(`/client/${clientId}/licenses/${licenseId}/download`, {
            responseType: "blob",
        });

        // Tworzenie linku do pobrania
        const blob = new Blob([response.data], { type: response.headers["content-type"] });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `License_${licenseId}.xml`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    /**
     * Usuwa licencję w kontekście klienta
     * @param clientId ID klienta
     * @param licenseId ID licencji
     */
    async deleteLicense(clientId: string, licenseId: string): Promise<void> {
        await axios.delete(`/client/${clientId}/licenses/${licenseId}`);
    }

}

export default new LicenseService();
